import { styled } from '@mui/material/styles';

const Divider = styled('div')`
  width: 100%;
  border-bottom: 0.5px solid;
  border-color: var(--mui-palette-grey-300);
`;

export default Divider;
